import React from "react";

import config from "../../../config";
import AhiChiclet from "../../AHI/AhiChiclet";
import Chiclet from "shared/Chiclet";

export default function ChicletRow({ parent, applyDiscreteSchemeColors }) {
  return parent.store.loading ? null : (
    <div className="chiclets color-scheme-dark">
      {config.ahi.enabled && (
        <AhiChiclet
          data={parent.store.ahiData}
          ahiDescriptions={parent.store.ahiDescriptions}
          disabled={!parent.store.liveMode || !parent.store.ahiData}
        />
      )}
      {parent.store.discretesRow &&
        parent.store.discretesRow
          .map(applyDiscreteSchemeColors)
          .map((discrete) => (
            <Chiclet
              chart={discrete}
              toggleChart={() =>
                !parent.props.disableTrends &&
                parent.trendStore.toggleTrendChart(discrete)
              }
              key={parent.trendStore.discreteKey(discrete)}
              active={parent.trendStore.isDiscreteActive(discrete)}
              showTrends={config.pm.showTrends}
            />
          ))}
    </div>
  );
}
